/**
 * @name                                    main.ts
 * @description                             main file of the project
*/


/* ---------------------------------------- PACK ----------------------------------------  */

    export *                                from './modules/types';
    export *                                from './modules/format';
    export *                                from './modules/pattern';

/* ---------------------------------------- ---- ----------------------------------------  */